import { render, staticRenderFns } from "./userPrize.vue?vue&type=template&id=55cf377e&scoped=true"
import script from "./userPrize.vue?vue&type=script&lang=js"
export * from "./userPrize.vue?vue&type=script&lang=js"
import style0 from "./userPrize.vue?vue&type=style&index=0&id=55cf377e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf377e",
  null
  
)

export default component.exports